import { connect } from 'react-redux'
import ModalActions from '../../../../../Redux/ModalRedux'
import DevicesBySiteModal from './device-by-site-modal'
import DevicesBySiteModalSelector from './device-by-site-modal.selector'
import { pipe } from 'ramda'
import { translate } from 'react-translate'

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch(ModalActions.modalClose())
  }
}

export default pipe(
  connect(
    DevicesBySiteModalSelector,
    mapDispatchToProps
  ),
  translate('CardsModals')
)(DevicesBySiteModal)
